import { computed, unref } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { useUISettings } from './useUISettings';
import { useAlert } from 'dashboard/composables';
import {
  hasPersonalConversationPreference,
  PINNED_CONVERSATION_IDS_KEY,
  QUIET_CONVERSATION_IDS_KEY,
  togglePersonalConversationPreference,
} from 'shared/helpers/conversationPersonalPreferences';

export const useConversationPersonalPreferences = conversationId => {
  const store = useStore();
  const { t } = useI18n();
  const { uiSettings, updateUISettings } = useUISettings();
  const resolvedConversationId = computed(() => unref(conversationId));

  const hasPreference = key =>
    computed(() =>
      hasPersonalConversationPreference(
        uiSettings.value,
        key,
        resolvedConversationId.value
      )
    );

  const togglePreference = key =>
    updateUISettings({
      [key]: togglePersonalConversationPreference(
        uiSettings.value,
        key,
        resolvedConversationId.value
      ),
    });

  const isPinned = hasPreference(PINNED_CONVERSATION_IDS_KEY);
  const isQuiet = hasPreference(QUIET_CONVERSATION_IDS_KEY);

  const togglePinned = async () => {
    try {
      await store.dispatch(
        isPinned.value ? 'toggleUnpin' : 'togglePin',
        resolvedConversationId.value
      );
      return true;
    } catch (error) {
      useAlert(t('CONVERSATION.PERSONAL_PREFERENCES.PIN_UPDATE_FAILED'));
      return false;
    }
  };

  return {
    isPinned,
    isQuiet,
    togglePinned,
    toggleQuiet: () => togglePreference(QUIET_CONVERSATION_IDS_KEY),
  };
};
